// utility/firebaseStorage.js
import { db } from '@/firebase'

export default {
    presenceRef: null,
    typingRef: null,
    db, // optional: store the db reference if needed
}
